import Slider from 'react-slick'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { Box } from '@material-ui/core'
import { testimonials } from '../utils/testimonials'
import usericon from '../../Assets/layout_images/user-icon.png'

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={`${className} arrow_slick`}
            style={style}
            onClick={onClick}
        >
            <ChevronRightIcon style={{ color: '#222', fontSize: '20px' }} />
        </div>
    )
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    
    return (
        <div
            className={`${className} arrow_slick`}
            style={style}
            onClick={onClick}
        >
            <ChevronLeftIcon style={{ color: '#222', fontSize: '20px' }} />
        </div>
    )
}

export default function StudentTestimonials({ type}) {
    if(type){
        var LandingTestimonials = [
                {
                    name: 'Sufiyan',
                    role: '7th Class Student',
                    saying: `Online tuition for ${type} science and mathematics at teacherInd really changed my Class 7 experience. The tutors made tough concepts easy to understand, and I now feel much more confident for my exams!`
                },
                {
                    name: 'Agnes',
                    role: "9th Class Student Brenda's Parent",
                    saying: `We're grateful for teacherInd's online tuition for mathematics. My child has improved greatly in ${type} Class 9 , and the tutors make learning engaging. Highly recommended for quality education.`
                },
                {
                    name: 'Sooraj',
                    role: '10th Class Student',
                    saying: `I had a hard time with Hindi and English in Class 10 ${type}, but teacherInd’s online tuition for Hindi and English turned things around for me. The support from tutors made all the difference`
                }
        ]
    }else{
        var LandingTestimonials = testimonials
    }
    var settings = {
        dots: true,
        infinite: true,
        autoplaySpeed: 3000,
        autoplay: true,
        slidesToShow: 3,
        swipeToSlide: true,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        cssEase: 'ease-in-out',

        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    }
    return (
        <div className="testimonials_home">
            <div>
                <h2 className="font-Quick font-semi">What Our Students Say</h2>
                <Box width="95%" maxWidth="1150px" margin="auto">
                    <Slider {...settings}>
                        {LandingTestimonials.map((item, key) => (
                            <div className="testimonial_wrapper" key={key}>
                                <div>
                                    <div className="testimonial_content_wrapper">
                                        <div className="testimonial_image" style={{backgroundColor:'white'}}>
                                            <img
                                                src={usericon}
                                                alt={item.name}
                                            />
                                        </div>

                                        <h3 className="font-Quick font-semi">
                                            {item.name}
                                        </h3>
                                        <p className="font-Quick font-semi testimonial_role">
                                            {item.role}
                                        </p>
                                    </div>
                                    <p className="font-Quick font-med testimonial_saying">
                                        {item.saying}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </Box>
            </div>
        </div>
    )
}
